<template>
  <div class="user--profile--root">
    <div class="ui basic segment">
      <h2 class="dashboard--title ui header">
        User Profile
      </h2>
    </div>
    <form class="ui form">
      <!-- avatar -->
      <div class="field">
        <label>Profile Picture</label>
        <input type="file" ref="fileInput" placeholder="Profile Picture" v-on:change="uploadTheLogo" accept="image/*" v-show="!userData.avatar_url">
        <div class="temp--logo" v-if="!previewImage">
          <img :src="userData.avatar_url" v-if="userData.avatar_url" style="height: 100px;">
          <i class="icon close" v-if="userData.avatar_url" @click="removeTempImage"></i>
        </div>
        <p>{{ msg }}</p>
        <img :src="previewImage" v-if="previewImage" style="height: 100px;">
        
      </div>

      <div class="field" :class="{ error: errors.username }">
        <label>Username</label>
        <input type="text" v-model="userData.username" placeholder="Username" disabled readonly style="background: #e5e5e5;">
        <div class="ui red pointing label" v-if="errors.username">{{ errors.username }}</div>
      </div>
      <div class="field" :class="{ error: errors.first_name }">
        <label>First Name</label>
        <input type="text" v-model="userData.first_name" placeholder="First Name">
        <div class="ui red pointing label" v-if="errors.first_name">{{ errors.first_name }}</div>
      </div>
      <div class="field" :class="{ error: errors.last_name }">
        <label>Last Name</label>
        <input type="text" v-model="userData.last_name" placeholder="Last Name">
        <div class="ui red pointing label" v-if="errors.last_name">{{ errors.last_name }}</div>
      </div>
      <div class="field" :class="{ error: errors.email }">
        <label>Email</label>
        <input type="text" v-model="userData.email" placeholder="Email">
        <div class="ui red pointing label" v-if="errors.email">{{ errors.email }}</div>
      </div>
      <div class="field" :class="{ error: errors.password }">
        <label>Password</label>
        <input type="password" v-model="userData.password" placeholder="Password">
        <div class="ui red pointing label" v-if="errors.password">{{ errors.password }}</div>
      </div>
      <div class="field" :class="{ error: errors.phone }">
        <label>Phone</label>
        <input type="text" v-model="userData.phone" placeholder="Phone">
        <div class="ui red pointing label" v-if="errors.phone">{{ errors.phone }}</div>
      </div>
      <div class="sc--btn--group">
        <button href="#!" class="sc--btn" type="submit" @click.prevent="submitForm">
          Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'UserProfile',
  data() {
    return {
      userData: {},
      previewImage: '',
      msg: '',
      formValidate: false,
      authToken: localStorage.getItem('sjdifjsckdsjfosdf54520bearer'),
      errors: {
        username: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        phone: '',
      },
    }
  },
  async created() {
    await this.fetchUserData();
  },
  methods: {
    async fetchUserData() {
      try {
        const response = await fetch('/wp-json/custom/v1/user?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + ''
          , {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            credentials: 'same-origin',
            'user-id': localStorage.getItem('sjdifjsckdsjfosdf54520zzz'),
            'email': 'hello@men3m.com'
          }
        });

        const responseData = await response.json(); // Parse the JSON response

        if (response.ok && responseData.success) {
          this.userData = responseData.userr;
        } else {
          console.error('Failed to fetch user data:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
    removeTempImage () {
      this.userData.avatar_url = '';
    },
    uploadTheLogo(event) {
      this.userData.avatar_url = event.target.files[0];
      this.msg = 'Uploading...';
      const wpPostPoint = `/wp-json/wp/v2/media`;
      let theFile = this.userData.avatar_url;

      this.mediaName = theFile.name;

      let axiosConfig = {
        headers: {
          'Authorization': 'Bearer ' + this.authToken,
          'cache-control': 'no-cache',
          'content-disposition': `attachment; filename=${this.mediaName}`,
          'content-type': theFile.type
        }
      }

      let postData = theFile;
      let mediaURL = '';

      axios.post(wpPostPoint, postData, axiosConfig)
        .then(response => {
          mediaURL = response.data.source_url;
          this.mediaID = response.data.id * 1;
          this.userData.avatar_url = mediaURL;
          console.log('Media ID: ' + this.mediaID);
          console.log('Media URL: ' + mediaURL);
          this.msg = 'Upload Complete';
          this.previewImage = mediaURL;
          setTimeout(() => {
            this.msg = '';
          }, 5000);
        }).catch(function (error) {
          console.log('Error osn post: ' + error);
        });

    },
    updateUserData () {
      const wpPostPoint = `/wp-json/custom/v1/update-user`;
      const requestBody = {
        userData: this.userData,
        k__sjnb__sdfjn0547: localStorage.getItem('sjdifjsckdsjfosdf54520zzz')
      }
      let axiosConfig = {
        headers: {
          'Authorization': 'Bearer ' + this.authToken,
          'cache-control': 'no-cache',
          'content-type': 'application/json'
        },
        body: requestBody
      }
      axios.post(wpPostPoint, axiosConfig)
        .then(response => {
          console.log(response);
          // refresh page
          setTimeout(() => {
            location.reload();
          }, 2000);
        }).catch(function (error) {
          console.log('Error osn post: ' + error);
        });
    },
    validateForm() {
      if (this.userData.password && this.userData.password.length < 6) {
        this.errors.password = 'Your password must be at least 6 characters';
      }
      this.errors.email = this.userData.email ? '' : 'Please enter an email';
      if (this.userData.email && !this.validEmail(this.userData.email)) {
        this.errors.email = 'Please enter a valid email';
      }
      this.errors.username = this.userData.username ? '' : 'Please enter a username';
      this.errors.first_name = this.userData.first_name ? '' : 'Please enter a first name';
      this.errors.last_name = this.userData.last_name ? '' : 'Please enter a last name';
      this.errors.phone = this.userData.phone ? '' : 'Please enter a phone number';
      this.formIsValid = !Object.keys(this.errors).some(key => this.errors[key]);

    },
    formIsValid() {
      return !Object.keys(this.errors).some(key => this.errors[key]);
    },
    validEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    submitForm() {
      this.validateForm();
      if (this.formIsValid) {
        this.updateUserData();
      }
    }
  },
}
</script>

<style scoped lang="sass">

  .temp--logo, .temp--file
    position: relative

    .close
      cursor: pointer
      position: absolute
      top: 0
      left: 0
      background: rgba(0,0,0,0.5)
      color: #fff
      padding: 0.5rem
      height: 20px
      width: 20px
      display: flex
      justify-content: center
      align-items: center

      &:hover
        filter: invert(1)

  .temp--file
    background: #e5e5e5
    padding: 5px 10px 5px 40px 
    display: inline-block

    .close
      top: calc(50% - 10px)
      left: 5px
</style>